import { Address, erc4626Abi } from "viem"
import { useReadContract } from "wagmi"

import { MEZO_CHAIN, query } from "#/shared/constants"

export default function useVaultPosition(
  vaultAddress: Address,
  owner?: Address,
) {
  const {
    data: shares,
    isFetching: isFetchingBalanceOf,
    queryKey,
  } = useReadContract({
    abi: erc4626Abi,
    address: vaultAddress,
    functionName: "balanceOf",
    args: [owner!],
    chainId: MEZO_CHAIN.id,
    query: {
      enabled: !!owner,
      refetchInterval: query.DEFAULT_REFETCH_INTERVAL,
      staleTime: query.DEFAULT_STALE_TIME,
    },
  })

  const { data: assets, isFetching: isFetchingAssets } = useReadContract({
    abi: erc4626Abi,
    address: vaultAddress,
    functionName: "convertToAssets",
    args: [shares!],
    chainId: MEZO_CHAIN.id,
    query: {
      enabled: shares !== undefined,
      refetchInterval: query.DEFAULT_REFETCH_INTERVAL,
      staleTime: query.DEFAULT_STALE_TIME,
    },
  })

  return {
    assets,
    shares,
    isFetching: isFetchingAssets || isFetchingBalanceOf,
    queryKey,
  }
}
